import React from 'react';
import { SidebarFilter } from '../../filters/SidebarFilter';
import { SidebarFilterBoolean } from '../../filters/sidebarFilterItems';
import { orgsFields } from '../orgs.model';
import SearchOnSubmitInput from '../../filters/SearchOnSubmitInput';

export const OrganizationSidebarFilters = () => (
    <SidebarFilter>
        <>
            <SearchOnSubmitInput source="q" />

            <SidebarFilterBoolean label="WIC ID" value={orgsFields.requiresWicId} />
            <SidebarFilterBoolean label="Nurse Phone" value={orgsFields.nursePhone} />
            <SidebarFilterBoolean label="Enrollment Code Required" value={orgsFields.enrollmentCodeRequired} />
            <SidebarFilterBoolean label="Content Library Enabled" value={orgsFields.contentLibraryEnabled} />
        </>
    </SidebarFilter>
);
